import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "u-form-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.gridDivId,
    class: _normalizeClass(_ctx.gridKlassen)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.zellenKlassen)
    }, [
      _createElementVNode("h2", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.titel) + " ", 1),
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.zeigeInfo && _ctx.infoBoxId)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "c-notice-icon",
              title: "Hilfe anzeigen",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.infoClick && _ctx.infoClick(...args)))
            }, [
              _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 10, _hoisted_1))
}